import "@babel/polyfill";
import "nodelist-foreach-polyfill";

const container = 1450;

const onResize = () => {
  if (window.innerWidth > 1024 && window.innerWidth <= container) {
    document.documentElement.style.fontSize = window.innerWidth * 0.043 + "%";
  } else {
    document.documentElement.style.fontSize = "62.5%";
  }
};

const responsivePage = () => {
  window.addEventListener("resize", onResize);
  window.addEventListener("load", onResize);
  window.addEventListener("orientationchange", onResize);
};

export default responsivePage;
